<template>
    <div class="scope-sidebar">
        <slot></slot>
    </div>
</template>

<style lang="scss" scoped>
@import '../assets/styles/_main.scss';

.scope-sidebar {
    width: 436px;
    height: 100%;
    border-left: 1px solid $border;
    @include shadow-medium;

    position: fixed;
    top: 0;
    right: 0;
    z-index: 120;
    background-color: $card-background;

    display: flex;
    flex-direction: column;
    overflow: auto;

    @media screen and (min-width: 1920px) {
        width: 561px;
    }
}
</style>
